import AuthState from "./context/Auth/AuthState";
import CheckCloseTableProvider from "./context/CheckCloseInformationTable/CheckCloseTableProvider";
import CheckOpenTableProvider from "./context/CheckOpenInformationTable/CheckOpenTableProvider";
import HistoricalReportProvider from "./context/HistoricalReports/HistoricalReportProvider";
import LoaderProvider from "./context/Loader/LoaderProvider";
import NotificationProvider from "./context/Notification/NotificationProvider";
import NotificationCountProvider from "./context/NotificationCount/NotificationCountProvider";
import SettingsProvider from "./context/Settings/SettingsProvider";
import ShowSuccessToastProvider from "./context/ShowSuccessToast/showSuccessToastProvider";
import LocationProvider from "./context/location/LocationProvider";
import ShowErrorToastProvider from "./context/showErrorToast/showErrorToastProvider";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <AuthState>
      <SettingsProvider>
        <LoaderProvider>
          <NotificationProvider>
            <HistoricalReportProvider>
              <LocationProvider>
                <CheckOpenTableProvider>
                  <CheckCloseTableProvider>
                    <NotificationCountProvider>
                      <ShowErrorToastProvider>
                        <ShowSuccessToastProvider>
                          <AppRoutes />
                        </ShowSuccessToastProvider>
                      </ShowErrorToastProvider>
                    </NotificationCountProvider>
                  </CheckCloseTableProvider>
                </CheckOpenTableProvider>
              </LocationProvider>
            </HistoricalReportProvider>
          </NotificationProvider>
        </LoaderProvider>
      </SettingsProvider>
    </AuthState>
  );
}

export default App;
